import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { css } from "@emotion/react";

export const subHeader = (theme: ExactTheme) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  flex-shrink: 0;
  min-height: 37px;
  padding: 0 15px;
  background-color: ${theme.colorsV2.grey[50]};
`;
